import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import '../../../../../VisualAssets/IconV3/index.js';
import { useSelectNative } from './hooks/useSelectNative.js';
import { IconV3 as IconV3Memoized } from '../../../../../VisualAssets/IconV3/Icon.js';

var _excluded = ["children"];
var SelectNative = /*#__PURE__*/React.memo(function (props) {
  var children = props.children,
    rest = _objectWithoutProperties(props, _excluded);
  var _useSelectNative = useSelectNative(),
    isDisabled = _useSelectNative.isDisabled,
    selectProps = _useSelectNative.selectProps;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("select", _extends({}, selectProps, rest), children), /*#__PURE__*/React.createElement(IconV3Memoized, {
    iconId: "fill.arrow.thick-dropdown",
    staticSize: "24",
    color: isDisabled ? 'state.disabled' : 'base.subtle'
  }));
});

export { SelectNative };
//# sourceMappingURL=SelectNative.js.map
